import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "row q-gutter-sm" };
const _hoisted_2 = { style: { "width": "350px" } };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_q_input = _resolveComponent("q-input");
    const _component_q_btn = _resolveComponent("q-btn");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_q_input, {
                dense: "",
                outlined: "",
                clearable: "",
                "clear-icon": "close",
                modelValue: _ctx.inputValue,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.inputValue) = $event)),
                placeholder: "物件名/号室/入居者名"
            }, null, 8, ["modelValue"])
        ]),
        _createVNode(_component_q_btn, {
            icon: "search",
            label: "検索",
            color: "green-7",
            onClick: _cache[1] || (_cache[1] = ($event) => (_ctx.applyFilter()))
        })
    ]));
}
